import keyMirror from 'keymirror';

export const MeasurementToolActionTypes: any = keyMirror({
  TURN_ON_MEASUREMENT_TOOL: undefined,
  TURN_OFF_MEASUREMENT_TOOL: undefined,
  ADD_STARTING_POINT: undefined,
  ADD_ENDING_POINT: undefined,
  START_NEW_MEASUREMENT: undefined,
  DELETE_MEASUREMENT: undefined,
  CLEAR_ALL_MEASUREMENTS: undefined,
  RESET_CURRENT_MEASUREMENT: undefined,
});
